import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import i18n from './i18n'
import ScrollAnimation from './directivas/scrollanimation'

/*
 Registre el objeto aquí globalmente como directiva,
 similar si registra un componente.
 Pero ahora con Vue.directive, en lugar de componente.
 Con esto puedes usar v-scrollanimation
 en toda su aplicación en cada elemento.
*/
Vue.directive('scrollanimation', ScrollAnimation);

new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: h => h(App)
}).$mount('#app')
